/** A sheet cell as a card prints it: blank for nothing, at most four decimals for a reading. */
export function formatCell(cell: unknown): string {
  if (cell === null || cell === undefined) return ''
  if (typeof cell === 'number') return Number.isInteger(cell) ? String(cell) : String(Number(cell.toFixed(4)))
  return String(cell)
}
